import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 384 512"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M303.8 241.7c2.084-1.838 4.41-3.307 6.385-5.303 22.72-22.91 35.03-53.31 34.72-85.59C344.3 85.31 290.4 32 224.9 32H24C10.75 32 0 42.75 0 56s10.75 24 24 24h24v352H24c-13.25 0-24 10.8-24 24s10.75 24 24 24h216c70.59 0 128-57.41 128-128 0-47.2-26.9-88.1-64.2-110.3M224.9 80c39.31 0 71.59 32 72 71.31.188 19.34-7.219 37.56-20.84 51.34C262.5 216.4 244.3 224 224.9 224H96V80zM240 432H96V272h144c44.13 0 80 35.88 80 80.01S284.1 432 240 432",
      style: {"fill":"var(--fa-primary-color, currentColor)","opacity":"var(--fa-primary-opacity, 1)"}
    }, null, -1)
  ])))
}
export default { render: render }